import AWS from 'aws-sdk/global';
import { getUser } from './config';

export default function() {
  const cognitoUser = getUser();
  if (cognitoUser) {
    if (AWS.config.credentials && AWS.config.credentials.clearCachedId) {
      AWS.config.credentials.clearCachedId();
    }
    cognitoUser.signOut();
    Promise.resolve();
  } else {
    throw new Error('no cognitiveUser value');
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/aws-cognito-redux-saga/aws-cognito-promises/signOut.js